import { storage } from "../firebase";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB
const ALLOWED_TYPES = [
  "application/pdf",
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "text/plain",
];

export function validateFile(file) {
  if (file.size > MAX_FILE_SIZE) {
    return "File must be under 10 MB.";
  }
  if (!ALLOWED_TYPES.includes(file.type)) {
    return "Unsupported file type. Allowed: PDF, images, Word docs, text files.";
  }
  return null;
}

export async function uploadJobAttachment(jobId, file) {
  const error = validateFile(file);
  if (error) throw new Error(error);

  const timestamp = Date.now();
  const safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, "_");
  const path = `jobs/${jobId}/attachments/${timestamp}_${safeName}`;
  const storageRef = ref(storage, path);

  await uploadBytes(storageRef, file, { contentType: file.type });
  const url = await getDownloadURL(storageRef);

  return {
    name: file.name,
    url,
    path,
    size: file.size,
    type: file.type,
    uploadedAt: new Date().toISOString(),
  };
}

export async function deleteJobAttachment(attachment) {
  if (!attachment.path) return;
  const storageRef = ref(storage, attachment.path);
  await deleteObject(storageRef);
}

export async function uploadOfficerDocument(userId, file) {
  const error = validateFile(file);
  if (error) throw new Error(error);

  const timestamp = Date.now();
  const safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, "_");
  const path = `officers/${userId}/documents/${timestamp}_${safeName}`;
  const storageRef = ref(storage, path);

  await uploadBytes(storageRef, file, { contentType: file.type });
  const url = await getDownloadURL(storageRef);

  return {
    name: file.name,
    url,
    path,
    size: file.size,
    type: file.type,
    uploadedAt: new Date().toISOString(),
  };
}

export async function deleteOfficerDocument(document) {
  if (!document.path) return;
  const storageRef = ref(storage, document.path);
  await deleteObject(storageRef);
}
